import React, { useEffect, useState } from "react";
import "./styles.scss";
import { CSpinner } from "@coreui/react";
import { themeColor, themeGold } from "src/utilities/CommonConstants";

const index = (props) => {
  const { classDTO, handleClassDTO, handleButtons } = props;

  const [state, updateStateValue] = useState({});
  const setState = (value) => {
    updateStateValue((prevState) => ({
      ...prevState,
      ...value,
    }));
  };

  useEffect(() => {
    // Anything in here is fired on component mount.
    return () => {
      // Anything in here is fired on component unmount.
    };
  }, []);

  return (
    <div id="root">
      <div className="loader-container">
        {/* <img src="assets/images/loader.gif" alt="Loading..."></img> */}
        <CSpinner style={{ color: themeColor }} /> Loading...
      </div>
    </div>
  );
};

export default index;
